export default [
  {
    name: 'project_file_download',
    component_path: 'modules/templates/blocks/project/ProjectFileDownload'
  }
]